<template lang="html">
  <div class="boutique">
    <h1 class="boutique-title">热门好课</h1>
    <ul class="boutique-main">
      <li v-for="(item, index) in popularCourses" :key="index">
        <course-item :course="item"></course-item>
      </li>
    </ul>
  </div>
</template>

<script>
import CourseItem from '../CourseItem'
export default {
  name: 'Boutique',
  props: {
    popularCourses: {
      type: Array,
      default: []
    }
  },
  components: {
    CourseItem
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.boutique {
  padding-bottom: rem(80);
  &-title {
    padding-left: rem(30);
    font-size: rem(36);
    font-weight: bolder;
  }
}
</style>
